export default {
  methods: {},
  on: {
    pageInit() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      let establecimiento = JSON.parse(localStorage.getItem('_establecimiento'));
      let urlImagen = "static/wm-logo.png";
      $('.page[data-name="popup-info"] .nombre-establecimiento').text(establecimiento.nombre);

      if (establecimiento.imagen) {
        urlImagen = window.global.url + "imagen/establecimiento/" + establecimiento.id_establecimiento + "/" + establecimiento.imagen;
        $('.img-establecimiento').attr('src', urlImagen);
      }

      if (establecimiento.direccion && establecimiento.direccion != "") {
        let link = "https://www.google.com/maps/search/?api=1&query=" + establecimiento.direccion;
        $('.page[data-name="popup-info"] .li-info-direccion .item-title').text(establecimiento.direccion);
        $('.page[data-name="popup-info"] .li-info-direccion a').attr('href', link);
        $('.page[data-name="popup-info"] .li-info-direccion').removeClass('display-none');
      }

      if (establecimiento.horarios && establecimiento.horarios != "") {
        $('.page[data-name="popup-info"] .li-info-horarios .item-title').text(establecimiento.horarios);
        $('.page[data-name="popup-info"] .li-info-horarios').removeClass('display-none');
      }

      if (establecimiento.whatsapp && establecimiento.whatsapp != "") {
        let link = "https://wa.me/" + establecimiento.whatsapp;
        $('.page[data-name="popup-info"] .li-info-whatsapp .item-title').text(establecimiento.whatsapp);
        $('.page[data-name="popup-info"] .li-info-whatsapp a').attr('href', link);
        $('.page[data-name="popup-info"] .li-info-whatsapp').removeClass('display-none');
      }

      if (establecimiento.telefono && establecimiento.telefono != "") {
        $('.page[data-name="popup-info"] .li-info-telefono .item-title').text(establecimiento.telefono);
        $('.page[data-name="popup-info"] .li-info-telefono').removeClass('display-none');
      }

      if (establecimiento.email && establecimiento.email != "") {
        $('.page[data-name="popup-info"] .li-info-email .item-title').text(establecimiento.email);
        $('.page[data-name="popup-info"] .li-info-email').removeClass('display-none');
      }

      if (establecimiento.facebook && establecimiento.facebook != "") {
        let link = establecimiento.facebook;
        $('.page[data-name="popup-info"] .li-info-facebook a').attr('href', link);
        $('.page[data-name="popup-info"] .li-info-facebook').removeClass('display-none');
      }

      if (establecimiento.instagram && establecimiento.instagram != "") {
        let link = establecimiento.instagram;
        $('.page[data-name="popup-info"] .li-info-instagram a').attr('href', link);
        $('.page[data-name="popup-info"] .li-info-instagram').removeClass('display-none');
      }
    }

  },
  id: 'f2f6349331',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=popup-info><div class=navbar><div class=navbar-bg></div><div class=navbar-inner><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Atrás</span></a></div><div class=title>Información</div><div class=right></div></div></div><div class=page-content><div class=block><div class=text-align-center><img src="" class=img-establecimiento alt=""></div></div><div class="block text-align-center"><h2 class=nombre-establecimiento></h2></div><div class="list no-hairlines"><ul><li class="li-info-direccion display-none"><a href=# target=_blank class="item-link item-content link external"><div class=item-media><i class="icon material-icons md-only">place</i><i class="icon f7-icons ios-only">map_pin</i></div><div class=item-inner><div class="item-title text-color-blue"></div></div></a></li><li class="li-info-horarios display-none"><div class=item-content><div class=item-media><i class="icon material-icons md-only">schedule</i> <i class="icon f7-icons ios-only">clock</i></div><div class=item-inner><div class=item-title style="--f7-list-item-title-white-space: none;"></div></div></div></li><li class="li-info-whatsapp display-none"><a href=# target=_blank class="item-link item-content link external"><div class=item-media><i class="icon fab fa-whatsapp"></i></div><div class=item-inner><div class="item-title text-color-blue"></div></div></a></li><li class="li-info-telefono display-none"><div class=item-content><div class=item-media><i class="icon material-icons md-only">phone</i> <i class="icon f7-icons ios-only">phone</i></div><div class=item-inner><div class=item-title></div></div></div></li><li class="li-info-email display-none"><div class=item-content><div class=item-media><i class="icon material-icons md-only">mail</i> <i class="icon f7-icons ios-only">envelope</i></div><div class=item-inner><div class=item-title>establecimiento.email</div></div></div></li><li class="li-info-facebook display-none"><a href=# target=_blank class="item-link item-content link external"><div class=item-media><i class="icon fab fa-facebook md-only"></i><i class="icon f7-icons ios-only">logo_facebook</i></div><div class=item-inner><div class=item-title>Facebook</div></div></a></li><li class="li-info-instagram display-none"><a href=# target=_blank class="item-link item-content link external"><div class=item-media><i class="icon fab fa-instagram md-only"></i><i class="icon f7-icons ios-only">logo_instagram</i></div><div class=item-inner><div class=item-title>Instagram</div></div></a></li></ul></div></div></div>';
      return r;
    }(this);
  },

  style: `
    .img-establecimiento {
        max-width: 100%;
        max-height: 140px;
    }
`,
  styleScoped: false
};